import Chip from "@mui/material/Chip/Chip"
import React from "react"

export default function FeeDisplay({ feebps }: { feebps: number }) {
  const formatted = (feebps / 100).toFixed(2)

  return (
    <Chip
      label={`${formatted}%`}
      size="small"
      variant="outlined"
      sx={{
        fontSize: "0.75rem",
        border: "0px",
        color: "var(--color-text-secondary-main)",
      }}
    />
  )
}
